import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import { Button } from 'react-bootstrap';
import CardSection from 'components/sales/cardSection/cardSectionNew';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import Images from 'assets/images/imageData';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';

const PMList = ({
  fetchPmGateDetails,
  pmListData,
  engineerList,
  engineerListData,
  match,
  history,
  siteSchedule,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [modalNote, setModalNote] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [selectedEngineer, setSelectedEngineer] = useState(null);

  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    if (fetchPmGateDetails !== null && match.params.id) {
      (async () => {
        setIsLoading(true);
        await fetchPmGateDetails(match.params.id);
        setIsLoading(false);
      })();
    }
  }, [fetchPmGateDetails, match.params.id]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await engineerList();
      setIsLoading(false);
    })();
  }, [engineerList]);

  useEffect(() => {
    if (pmListData) {
      setListData(pmListData.result);
    }
  }, [pmListData]);

  const goToCardDetails = (id) => {
    history.push({
      pathname: `/dashboard/pm_checklist/${match.params.id}`,
      state: { gate_id: id },
    });
  };

  const completeStage = async () => {
    let count = 0;
    if (listData && listData.length > 0) {
      listData.forEach((obj) => {
        if (obj.status === 'Not Completed') {
          count += 1;
        }
      });
      if (count === 0) {
        const res = await siteSchedule(match.params.id, selectedEngineer);
        if (res === true) {
          setIsModal(true);
        }
      } else {
        setModalNote(true);
      }
    }
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          className="btn btn-primary d-md-inline-block "
          onClick={() => {
            completeStage();
          }}
          disabled={!selectedEngineer}
        >
          {localization.scheduleFirstMaintaince}
        </Button>
      </Fragment>
    );
  };

  {console.log(engineerListData)}
  return (
    <Layout
      title={localization.createPMChecklist}
      isGoback
      Buttons={headerBtns}
      isLoading={isLoading}
      linkUrl={`${baseUrl}/go-live-site`}
    >
      <CardSection className="col-md-6" title={`PM Software`}>
        <div className="">
          <DropDownInput
            label={localization.selectPmEngineer}
            required
            errorMsg={localization.requiredName}
            data = {engineerListData}
            isStarRequired={true}
            getIdValue={(selectedValue) =>
              setSelectedEngineer(selectedValue.id)
            }
          />
        </div>
      </CardSection>

      <div>
        {pmListData && pmListData.site_data && (
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <h4>
                {pmListData.site_data.client_name} (
                {pmListData.site_data.site_no})
              </h4>
            </div>
          </div>
        )}

        {listData &&
          listData.map((obj, index) => {
            return (
              <CardSection title={`Solution ${obj.gate_no}`} key={index}>
                <div className="col-md-12">
                  <h4>{obj.gate_name ? obj.gate_name : null}</h4>
                </div>
                <div className="col-md-12">
                  <Button
                    disabled={obj.status === 'Completed'}
                    className={
                      obj.status === 'Completed'
                        ? 'url-card card-success'
                        : 'url-card card-danger'
                    }
                    onClick={() => {
                      goToCardDetails(obj.gate_id);
                    }}
                  >
                    {obj.checklist_name}
                  </Button>
                </div>
              </CardSection>
            );
          })}

        <ModalPop
          title={localization.conf}
          show={isModal}
          handleModalHide={handleModalHide}
          keyboard
          backdrop
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{localization.assignedSuccessfully}</h5>
            <Link to={`${baseUrl}/go-live-site`} className="btn btn-primary mb-4">
              {localization.goLiveSites} <img src={Images?.ArrowRight} alt="" />
            </Link>
          </div>
        </ModalPop>

        <ModalPop
          title={localization.note}
          show={modalNote}
          handleModalHide={() => {
            setModalNote(false);
          }}
          keyboard
          backdrop
        >
          <div className="text-center">
            <h5>{localization.ChecklistNote}</h5>
          </div>
        </ModalPop>
      </div>
    </Layout>
  );
};

export default PMList;
